import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Tooltip } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import LockIcon from "@material-ui/icons/Lock";
import useStyles from "./FormShell.styles";
import { SectionStatusShape } from "./formShell.propTypes";
import { SECTION_STATE, getSectionState } from "./formShell.status";

/** Accordion-header badge (branches from Add_Loan's section badge). */
function SectionStatusBadge({
  status,
  lockedTooltip,
  optionalCountsAsComplete = true,
}) {
  const classes = useStyles();
  const state = getSectionState(status, { optionalCountsAsComplete });

  if (state === SECTION_STATE.LOCKED) {
    // Tooltip needs a real element child (a <span>, not a fragment) for its ref.
    const badge = (
      <span className={clsx(classes.sectionBadge, classes.badgeLocked)}>
        <LockIcon style={{ fontSize: "1rem" }} />
        Locked
      </span>
    );
    return lockedTooltip ? (
      <Tooltip title={lockedTooltip} arrow placement="top">
        {badge}
      </Tooltip>
    ) : (
      badge
    );
  }

  if (state === SECTION_STATE.ERROR) {
    return (
      <span className={clsx(classes.sectionBadge, classes.badgeError)}>
        <ErrorOutlineIcon style={{ fontSize: "1rem" }} />
        {status.errorCount} {status.errorCount === 1 ? "issue" : "issues"}
      </span>
    );
  }

  if (state === SECTION_STATE.COMPLETE) {
    return (
      <span className={clsx(classes.sectionBadge, classes.badgeComplete)}>
        <CheckCircleIcon style={{ fontSize: "1rem" }} />
        Complete
      </span>
    );
  }

  if (state === SECTION_STATE.PARTIAL) {
    return (
      <span className={clsx(classes.sectionBadge, classes.badgePartial)}>
        {status.filledRequired}/{status.requiredTotal}
      </span>
    );
  }

  return (
    <span className={clsx(classes.sectionBadge, classes.badgeOptional)}>
      Optional
    </span>
  );
}

SectionStatusBadge.propTypes = {
  status: SectionStatusShape.isRequired,
  lockedTooltip: PropTypes.node,
  optionalCountsAsComplete: PropTypes.bool,
};

export default SectionStatusBadge;
